import { NavLink } from 'react-router'

import type { SidebarLink } from './model'
import { SidebarRowIcon } from './SidebarRowIcon'
import { SidebarRowTooltip } from './SidebarRowTooltip'

/** One sidebar row: a link, or a button that changes the sidebar rather than the page. */
export const SIDEBAR_ROW =
  'flex h-8 w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-hidden transition-[width,height,padding] motion-reduce:transition-none hover:bg-ink-50 hover:text-ink focus-visible:ring-brand-700/50 focus-visible:ring-[3px] active:bg-ink-50 active:text-ink aria-[current=page]:font-semibold group-data-[collapsible=icon]:size-8! group-data-[collapsible=icon]:p-2! [&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:text-ink-400 aria-[current=page]:[&_svg]:text-ink-900 [&>span:last-child]:truncate'

interface SidebarNavLinkProps {
  link: SidebarLink
  /** The row's place in its group, which staggers the collapsed-rail icon swap. */
  index: number
}

export function SidebarNavLink({ link, index }: SidebarNavLinkProps) {
  const content = (
    <>
      <SidebarRowIcon icon={link.icon} collapsedIcon={link.collapsedIcon} index={index} />
      <span>{link.title}</span>
    </>
  )

  // Another app's page is a full page load, and never the page we are on.
  if (link.url.startsWith('http')) {
    return (
      <SidebarRowTooltip label={link.title}>
        <a href={link.url} className={SIDEBAR_ROW}>
          {content}
        </a>
      </SidebarRowTooltip>
    )
  }
  return (
    <SidebarRowTooltip label={link.title}>
      <NavLink to={link.url} end={link.exact} className={SIDEBAR_ROW}>
        {content}
      </NavLink>
    </SidebarRowTooltip>
  )
}
